export default __webpack_public_path__ + "static/media/award23.70c87030.svg";